module.exports = __webpack_public_path__ + "img/tickets.504b1c8e.svg";